import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import ShopView from '../views/ShopView.vue'
import ContactView from '../views/ContactView.vue'
import ShopDuvets from '../views/ShopDuvets.vue'
import ShopPillows from '../views/ShopPillows.vue'
import CartView from '../views/CartView.vue'
import CareView from '../views/CareView.vue'
import CartBuyer from '../views/CartBuyer.vue'
import SumupView from '../views/SumupView.vue'
import ThankYou from '../views/ThankYou.vue'
import ThankYouP24 from '../views/ThankYouP24.vue'
import Rules from '../views/RulesView.vue'
import Privacy from '../views/PrivacyPolicy.vue'
import Cennik from '../views/CennikView.vue'
//ADMIN
import AdminLogin from '../views/AdminLogin.vue'
import AdminPanel from '../views/AdminPanel.vue'
import AdminCoupons from '../views/AdminCoupons.vue'
import AdminOrders from '../views/AdminOrders.vue'
import AdminArchiveOrders from '../views/AdminArchiveOrders.vue'
import AdminStorage from '../views/AdminStorage.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/sklep',
    name: 'sklep',
    component: ShopView
  },
  {
    path: '/kontakt',
    name: 'kontakt',
    component: ContactView
  },
  {
    path: '/sklep_koldry',
    name: 'sklep_koldry',
    component: ShopDuvets
  },
  {
    path: '/sklep_poduszki',
    name: 'sklep_poduszki',
    component: ShopPillows
  },
  {
    path: '/koszyk',
    name: 'koszyk',
    component: CartView
  },
  {
    path: '/pielegnacja',
    name: 'pielegnacja',
    component: CareView
  },
  {
    path: '/koszyk-dane',
    name: 'koszyk-dane',
    component: CartBuyer,
  },
  {
    path: '/podsumowanie',
    name: 'podsumowanie',
    component: SumupView,
  },
  {
    path: '/thankyou',
    name: 'ThankYou',
    component: ThankYou,
  },
  {
    path: '/thankyouP24',
    name: 'ThankYouP24',
    component: ThankYouP24,
  },
  {
    path: '/regulamin',
    name: 'Regulamin',
    component: Rules,
  },
  {
    path: '/polityka-prywatnosci',
    name: 'Polityka Prywatnosci',
    component: Privacy,
  },
  {
    path: '/cennik',
    name: 'Cennik',
    component: Cennik,
  },

  //ADMIN
  {
    path: '/AdminLogin',
    name: 'AdminLogin',
    component: AdminLogin,
  },
  {
    path: '/AdminPanel',
    name: 'AdminPanel',
    component: AdminPanel,
  },
  {
    path: '/AdminCoupons',
    name: 'AdminCoupons',
    component: AdminCoupons,
  },
  {
    path: '/AdminOrders',
    name: 'AdminOrders',
    component: AdminOrders,
  },
  {
    path: '/AdminArchiveOrders',
    name: 'AdminArchiveOrders',
    component: AdminArchiveOrders,
  },
  {
    path: '/AdminStorage',
    name: 'AdminStorage',
    component: AdminStorage,
  }
]

const router = createRouter({
  //history: createWebHashHistory(),
  history: createWebHistory(),
  routes
})

export default router
